/**
 * A drawn bell rather than the 🔔 emoji, which rendered in its own colours and at its own
 * weight and sat oddly beside the sidebar's monochrome glyphs. Strokes use currentColor, so
 * it takes the theme and the hover state like everything else.
 */
export function BellIcon({ size = 17 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M18 8a6 6 0 1 0-12 0c0 5-2 6-2 6h16s-2-1-2-6" />
      <path d="M10.3 20a2 2 0 0 0 3.4 0" />
    </svg>
  );
}
